var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},[_c('span',{staticClass:"icon"},[_c('a',{attrs:{"href":_vm.twitter,"target":"_blank"}},[_c('i',{staticClass:"fa fa-twitter"})])]),_vm._v(" "),_c('span',{staticClass:"icon"},[_c('a',{attrs:{"href":_vm.facebook,"target":"_blank"}},[_c('i',{staticClass:"fa fa-facebook"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d20b5d2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./partials/HubShare.vue
// module id = 84
// module chunks = 0